import store from "@/store/store";

export const authRoutes = {
  path: "/auth",
  children: [
    {
      path: "login",
      name: "Login",
      beforeEnter: async (to, from, next) => {
        // The login UI sets the credential cookies and sends the browser
        // here. Load the profile fresh (never a cached one) and move on.
        //
        // TAIR3-995: this used to force a full page reload after the
        // redirect, which threw away the profile just loaded and loaded it
        // again (two more PAM calls and two more Oracle queries), doubling
        // the chances of a hiccup. App.vue now bootstraps on every route and
        // the navbar reacts to the store, so no reload is needed.
        const loaded = await store.dispatch("authProfile/loadAuthProfile");
        if (loaded && store.getters["authProfile/isLoggedIn"]) {
          next({ path: "/linktoorcid" });
        } else {
          next({ path: "/" });
        }
      },
    },
    {
      path: "logout",
      name: "Logout",
      beforeEnter: async (to, from, next) => {
        await store.dispatch("authProfile/invalidate");
        next({ path: "/" });
        window.location.reload();
      },
    },
  ],
};